const INITIAL_STATE = {
  data: {},
  errors: {},

}
const sendInvoiceReminder = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'SEND_INVOICE_REMINDERS_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'SEND_INVOICE_REMINDERS_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default sendInvoiceReminder;